import { render, staticRenderFns } from "./DropShadow.vue?vue&type=template&id=38136bd2&"
import script from "./DropShadow.vue?vue&type=script&lang=js&"
export * from "./DropShadow.vue?vue&type=script&lang=js&"
import style0 from "./DropShadow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports